// Palette de Kelly (maximally distinct). On évite blanc/noir.
// Réf utile : 20 teintes très espacées perceptuellement.
const KELLY = [
  "#4caf50", 
  "#1976d2", 
  "#d32f2f", 
  "#2761F5", 
  "#C827F5", 
  "#F527EB", 
  "#27E4F5", 
  "#BECDCF", 
  "#08171A", 
  "#929460", 
  "#FF7A5C", 
  "#53377A", 
  "#FF8E00", 
  "#B32851", 
  "#F4C800", 
  "#7F180D", 
  "#93AA00", 
  "#593315", 
  "#F13A13", 
  "#232C16", 
];

// ordre “éloigné” : on pioche avec un pas premier (ex: 7) pour éviter
// que deux séries adjacentes aient des teintes voisines.
const ORDER = [0, 9, 2, 7, 4, 16, 11, 14, 13, 3, 12, 1, 18, 5, 8, 19, 6, 10, 17, 15];

const colorAt = (i: number) => KELLY[ORDER[i % ORDER.length]];

const hexToRgba = (hex: string, a: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export const getBorderColor = (index: number): string => colorAt(index);

// un peu plus opaque pour bien distinguer les barres
export const getBackgroundColor = (index: number): string =>
  hexToRgba(colorAt(index), 0.7);
